<template>
  <div class="rt-header">
    <slot />
    <div v-if="hasBottom" class="header-bottom">
      <slot name="bottom" />
    </div>
    <el-collapse-transition>
      <div v-show="state.showMore">
        <slot name="extra" />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import { store } from '../table/store';
export default {
  name: 'RtHeader',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    autoBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      state: store.state
    };
  },
  computed: {
    hasBottom() {
      return !!this.$slots.bottom;
    }
  },
  methods: {
    back() {
      if (this.autoBack) {
        this.$route.back();
        return;
      }
      this.$emit('back');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeader.vue?320e0098